__webpack_require__.p = "https://uat.orde.byonde.asia/";